import pickBy from 'lodash/pickBy';

const predicate = (value: unknown) => {
    if (value === null || value === undefined || typeof value === 'string' && !value.length) {
        return false;
    }
    return true;
};

export function removeEmptyValuesFromObject(obj: Record<string, unknown>) {
    return pickBy<Record<string, unknown>>(obj, predicate);
};
